import Api from '../api';
import qs from 'qs';

const SpeedrunLeaderboardAPI = {
  async getSpeedrunLeaderboardWithInstance(params) {
    return Api.get(`/speedrun-leaderboards?`, { params });
  },
  async getSpeedrunLeaderboardWithInstances(params) {
    return Api.get(`/speedrun-leaderboards/all-instances?`, { params });
  }
};

export default SpeedrunLeaderboardAPI;
